import { useEffect, useRef } from "react";

const AgentPopUp = (props) => {
  const popupref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    props.visible && (
      <div
        ref={popupref}
        a
        className="w-[250px] bg-white border border-gray-300 rounded-md p-[10px] absolute z-10 top-[50px] left-0"
        style={props.style}
      >
        <div className="w-full max-h-[120px] overflow-y-scroll">
          {/* "All Agents" option */}
          <div
            onClick={() => props.onClickcorrect("All Agents")}
            className="py-[5px] cursor-pointer hover:bg-themeColor hover:text-white text-textcolor px-[10px] rounded-xl"
          >
            All Agents
          </div>

          {[...(props.data || [])]
            .sort((a, b) =>
              `${a.firstname || ""} ${a.lastname || ""}`.localeCompare(
                `${b.firstname || ""} ${b.lastname || ""}`,
                undefined,
                { sensitivity: "base" },
              ),
            )
            .map((item, index) => {
              const label = `${item.firstname} ${item.lastname}`;

              return (
                <div
                  key={index}
                  onClick={() => props.onClickcorrect(item.id, label)}
                  className="flex items-center w-full py-[5px] cursor-pointer hover:bg-themeColor hover:text-white text-textcolor hover:px-[10px] hover:rounded-xl"
                >
                  <p className="font-medium PoppinsRegular text-sm ml-[10px]">
                    {label}
                  </p>
                </div>
              );
            })}
        </div>
      </div>
    )
  );
};

export default AgentPopUp;
